import { gql } from "@apollo/client";

export const GET_SALES_DASHBOARD = gql`
  query GetSalesDashboard($userId: String, $view: String, $date: String, $employeestatus: String, $loginUserId: String) {
    getSalesDashboard(userId: $userId, view: $view, date: $date, employeestatus: $employeestatus, loginUserId: $loginUserId) {
      employees {
        userId
        employeeName
        empId
        email
        department
        designation
        currentStatus
        loginTime
        isPrimarySales

        totalLeadsAssigned
        leadsCreatedToday
        leadsCreatedThisWeek
        leadsCreatedThisMonth

        callsToday
        emailsToday
        linkedinToday
        scheduledCallsToday

        callsThisWeek
        emailsThisWeek
        linkedinThisWeek

        callsThisMonth
        emailsThisMonth
        linkedinThisMonth

        pipelineDeals
        closedWon
        closedLost
        totalDealValue

        followUpsTotal
        followUpsDueToday
        followUpsOverdue

        opsCallsScheduled
        opsCallsConnected

        priorityBreakdown {
          priority
          count
        }
        stageBreakdown {
          stage
          count
          dealValue
        }
      }
      teamSummary {
        totalReps
        totalLeads
        newLeadsToday
        newLeadsThisWeek
        newLeadsThisMonth
        totalCallsToday
        totalEmailsToday
        totalLinkedinToday
        pipelineDeals
        pipelineValue
        closedWonCount
        closedWonValue
        followUpsDueToday
      }
      totalCount
    }
  }
`;
